import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/home/Hero';
import HowItWorks from './components/home/HowItWorks';
import PrivacyOwnership from './components/home/PrivacyOwnership';
import MethodBook from './components/home/MethodBook';
import WhatYouGet from './components/home/WhatYouGet';
import CardShowcase from './components/home/CardShowcase';
import PricingSection from './components/home/PricingSection';
import SocialProof from './components/home/SocialProof';
import UseCaseShowcase from './components/home/UseCaseShowcase';
import Faq from './components/home/Faq';
import CtaBanner from './components/home/CtaBanner';
import CustomCursor from './components/home/CustomCursor';
import { useCapability } from './components/home/three/useCapability';

function Home() {
  const capability = useCapability();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{
        bgcolor: theme.home.paper, color: theme.home.ink,
        // Custom cursor replaces the native one everywhere on the page while
        // active — descendants (Buttons, the tiltable card <img>s) set their
        // own `cursor: pointer`, which would otherwise win back the native
        // cursor exactly where the custom one is supposed to morph.
        // `!important` is required, not optional here: verified in a real
        // browser that plain `cursor: none` on `& *` LOSES to MUI's own
        // per-component `cursor: pointer` rules (e.g.
        // `.css-xxxx-MuiButtonBase-root-MuiButton-root { cursor: pointer }`)
        // — both selectors have equal specificity (one class + a universal
        // selector contributes nothing), and MUI's own rule is inserted into
        // the stylesheet LATER (as each button mounts, after this ancestor
        // Box's rule), so it wins the cascade tie by source order alone.
        ...(capability.renderCursor ? { cursor: 'none', '& *': { cursor: 'none !important' } } : {}),
      }}>
        {capability.renderCursor && <CustomCursor />}
        <Navbar />
        <Hero />
        <HowItWorks />
        <UseCaseShowcase />
        <PrivacyOwnership />
        <MethodBook />
        <WhatYouGet />
        <CardShowcase />
        <PricingSection />
        <SocialProof />
        <Faq />
        <CtaBanner />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default Home;
